import React from "react";
import { toast } from "sonner";
import { Paperclip } from "lucide-react";
import { Button } from "@/components/ui/button";
import { whatsappUrl, normalizePhone } from "@/lib/share";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M17.5 14.4c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.6c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4zM12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2z" />
  </svg>
);

// One-tap WhatsApp share. getText() returns the message body; onSharePdf(text) also attaches the PDF.
export default function ShareButtons({ getText, phone, countryCode, size = "default", idSuffix = "", onSharePdf, onBeforeShare }) {
  const sendWhatsApp = async () => {
    let text = getText();
    if (!text) return toast.error("Nothing to share yet");
    const win = onBeforeShare ? window.open("about:blank", "_blank") : null; // open synchronously so popup blockers allow it
    try { if (onBeforeShare) { const saved = await onBeforeShare(); text = getText(saved) || text; } } catch { win?.close(); return; } // re-read so the quote no. is included
    const url = whatsappUrl(phone, countryCode, text);
    if (win) win.location.href = url; else window.open(url, "_blank", "noopener");
    toast.success("Opening WhatsApp", { description: phone ? `To +${normalizePhone(phone, countryCode)}` : "Pick a contact in WhatsApp" });
  };

  const cls = size === "sm" ? "h-8 px-2 text-xs" : "";
  const label = "truncate";
  return (
    <>
      <Button size={size} onClick={sendWhatsApp} data-testid={`share-whatsapp-btn${idSuffix}`} title={phone ? `WhatsApp +${normalizePhone(phone, countryCode)}` : "WhatsApp"} className={`min-w-0 bg-[#25D366] hover:bg-[#1ebe5b] text-slate-950 font-bold ${cls}`}>
        <WhatsAppIcon className="w-4 h-4 mr-1.5 shrink-0" /><span className={label}>WhatsApp</span>
      </Button>
      {onSharePdf && (
        <Button size={size} onClick={() => onSharePdf(getText())} data-testid={`share-whatsapp-pdf-btn${idSuffix}`} title="WhatsApp with PDF attached" className={`min-w-0 bg-emerald-700 hover:bg-emerald-600 text-white font-bold ${cls}`}>
          <Paperclip className="w-4 h-4 mr-1.5 shrink-0" /><span className={label}>{size === "sm" ? "+ PDF" : "WhatsApp + PDF"}</span>
        </Button>
      )}
    </>
  );
}
